import styled, { css } from 'styled-components'
import { PersonAvatar as BaseAvatar } from '@sketch/components'

const Avatar = styled(BaseAvatar)<{ invitationRequested?: boolean }>`
  display: flex;

  ${({ invitationRequested }) =>
    invitationRequested &&
    css`
      opacity: 50%;
    `}
`

export { Avatar }
